// app/javascript/controllers/file_preview_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "title", "downloadLink"]

  connect() {
    // Bind escape key
    this.handleEscape = this.handleEscape.bind(this)
  }

  preview(event) {
    event.preventDefault()
    const button = event.currentTarget
    const fileUrl = button.dataset.filePreviewUrlValue
    const fileName = button.dataset.filePreviewTitleValue
    const fileType = button.dataset.filePreviewTypeValue
    const downloadUrl = button.dataset.filePreviewDownloadUrlValue || fileUrl

    if (!fileUrl) {
      return
    }

    // Mettre à jour le titre
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = fileName || 'Prévisualisation'
    }

    // Mettre à jour le lien de téléchargement
    if (this.hasDownloadLinkTarget) {
      this.downloadLinkTarget.href = downloadUrl
    }

    // Vider le contenu précédent
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = ''
    }

    // Créer le contenu selon le type de fichier
    if (fileType === 'image') {
      this.previewImage(fileUrl, fileName)
    } else if (fileType === 'pdf') {
      this.previewPdf(fileUrl, fileName)
    } else {
      this.previewGeneric(fileUrl, fileName)
    }

    // Afficher le modal
    this.show()
  }

  previewImage(url, fileName) {
    const img = document.createElement('img')
    img.src = url
    img.alt = fileName
    img.className = 'max-w-full max-h-[70vh] object-contain mx-auto'
    img.style.maxHeight = '70vh'

    img.onload = () => {
      // Image chargée avec succès
    }

    img.onerror = () => {
      this.showError('Impossible de charger l\'image')
    }

    this.contentTarget.appendChild(img)
  }

  previewPdf(url, fileName) {
    // Créer un iframe pour le PDF
    const iframe = document.createElement('iframe')
    iframe.src = url
    iframe.className = 'w-full border-0 rounded'
    iframe.style.height = '70vh'
    iframe.title = fileName

    iframe.onload = () => {
    }

    iframe.onerror = () => {
      this.showError('Impossible de charger le PDF')
    }

    this.contentTarget.appendChild(iframe)
  }

  previewGeneric(url, fileName) {
    const container = document.createElement('div')
    container.className = 'text-center py-8'

    container.innerHTML = `
      <div class="mb-4">
        <i class="fa-solid fa-file text-6xl text-gray-400"></i>
      </div>
      <p class="text-lg font-medium text-gray-700 mb-2">${fileName}</p>
      <p class="text-sm text-gray-500 mb-4">Prévisualisation non disponible pour ce type de fichier</p>
      <a href="${url}"
         target="_blank"
         class="inline-flex items-center px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
        <i class="fa-solid fa-external-link-alt mr-2"></i>
        Ouvrir dans un nouvel onglet
      </a>
    `

    this.contentTarget.appendChild(container)
  }

  showError(message) {
    const errorDiv = document.createElement('div')
    errorDiv.className = 'text-center py-8'
    errorDiv.innerHTML = `
      <div class="mb-4">
        <i class="fa-solid fa-exclamation-triangle text-6xl text-red-400"></i>
      </div>
      <p class="text-lg font-medium text-red-700">${message}</p>
    `
    this.contentTarget.appendChild(errorDiv)
  }

  show() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove('hidden')
      this.modalTarget.classList.add('flex')
      document.body.style.overflow = 'hidden'

      // Ajouter l'écouteur d'événement pour la touche Escape
      document.addEventListener('keydown', this.handleEscape)
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    if (this.hasModalTarget) {
      this.modalTarget.classList.add('hidden')
      this.modalTarget.classList.remove('flex')
      document.body.style.overflow = ''

      // Supprimer l'écouteur d'événement pour la touche Escape
      document.removeEventListener('keydown', this.handleEscape)

      // Vider le contenu pour libérer la mémoire
      if (this.hasContentTarget) {
        this.contentTarget.innerHTML = ''
      }
    }
  }

  clickOutside(event) {
    // Fermer si on clique en dehors du contenu du modal
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  disconnect() {
    // Nettoyer les écouteurs d'événements
    document.removeEventListener('keydown', this.handleEscape)
    document.body.style.overflow = ''
  }
}